/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S4_P2Inputs */

const tr_kvkkbasvuru_s4_p2 = /** @type {(inputs: Kvkkbasvuru_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başvurunun reddi, verilen yanıtın yetersiz bulunması veya süresinde cevap verilmemesi hallerinde, cevabı öğrendiği tarihten itibaren 30 gün ve her halükarda başvuru tarihinden itibaren 60 gün içinde Kişisel Verileri Koruma Kurulu'na şikâyette bulunabilirsiniz.`)
};

const en_kvkkbasvuru_s4_p2 = /** @type {(inputs: Kvkkbasvuru_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the application is rejected, the response given is found insufficient or no reply is given within the period, you may lodge a complaint with the Kişisel Verileri Koruma Kurulu within 30 days from the date you learn of the response and in any case within 60 days from the date of the application.`)
};

const de_kvkkbasvuru_s4_p2 = /** @type {(inputs: Kvkkbasvuru_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird der Antrag abgelehnt, die erteilte Antwort als unzureichend erachtet oder nicht fristgerecht geantwortet, können Sie innerhalb von 30 Tagen ab Kenntnis der Antwort und in jedem Fall innerhalb von 60 Tagen ab dem Datum des Antrags Beschwerde bei der Kişisel Verileri Koruma Kurulu einlegen.`)
};

const ru_kvkkbasvuru_s4_p2 = /** @type {(inputs: Kvkkbasvuru_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В случае отклонения обращения, признания данного ответа недостаточным или отсутствия ответа в установленный срок вы можете подать жалобу в Kişisel Verileri Koruma Kurulu в течение 30 дней со дня, когда вам стало известно об ответе, и в любом случае в течение 60 дней со дня подачи обращения.`)
};

/**
* | output |
* | --- |
* | "If the application is rejected, the response given is found insufficient or no reply is given within the period, you may lodge a complaint with the Kişisel V..." |
*
* @param {Kvkkbasvuru_S4_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s4_p2 = /** @type {((inputs?: Kvkkbasvuru_S4_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S4_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s4_p2(inputs)
	if (locale === "de") return de_kvkkbasvuru_s4_p2(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s4_p2(inputs)
	return tr_kvkkbasvuru_s4_p2(inputs)
});